import { motion, Variants } from 'framer-motion';
import * as React from 'react';
import { sun } from '../scss/icon.mod.scss';

function SunIcon(props: React.SVGProps<SVGSVGElement>) {
  const variants: Variants = {
    hidden: { x: 100 },
    visible: {
      transition: { duration: 1, ease: 'easeInOut' },
      x: 0,
    },
  };

  return (
    <svg
      viewBox="0 0 92 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={sun}
    >
      <motion.path
        d="M46 64.194c14.372 0 26.023-10.385 26.023-23.195S60.372 17.805 46 17.805 19.977 28.19 19.977 41c0 12.81 11.65 23.195 26.023 23.195zM46 9.105c-.767 0-1.39-.555-1.39-1.24V1.24C44.61.555 45.233 0 46 0c.768 0 1.39.555 1.39 1.24v6.626c0 .684-.622 1.239-1.39 1.239zM27.413 13.544c-.48 0-.947-.222-1.205-.62l-3.717-5.738c-.384-.593-.156-1.35.509-1.693.665-.342 1.515-.14 1.9.454l3.716 5.738c.384.593.157 1.35-.508 1.693-.22.113-.459.166-.695.166zM13.804 25.672c-.236 0-.475-.053-.694-.166l-6.438-3.313c-.665-.342-.893-1.1-.509-1.693s1.234-.796 1.9-.454L14.5 23.36c.665.342.892 1.1.508 1.692-.257.398-.724.62-1.205.62zM8.825 42.24H1.39C.622 42.24 0 41.683 0 41c0-.684.622-1.24 1.39-1.24h7.435c.768 0 1.39.556 1.39 1.24 0 .684-.622 1.24-1.39 1.24zM7.368 62.12c-.48 0-.947-.222-1.205-.62-.384-.593-.156-1.35.509-1.693l6.439-3.313c.664-.342 1.515-.14 1.899.454.383.592.156 1.35-.51 1.692l-6.438 3.314a1.518 1.518 0 01-.694.166zM23.694 76.673c-.236 0-.475-.053-.694-.166-.665-.342-.893-1.1-.509-1.693l3.717-5.738c.384-.593 1.234-.796 1.9-.454.664.342.892 1.1.508 1.693L24.9 76.053c-.258.398-.725.62-1.205.62zM46 82c-.767 0-1.39-.555-1.39-1.24v-6.626c0-.684.623-1.239 1.39-1.239.768 0 1.39.555 1.39 1.24v6.626c0 .684-.622 1.239-1.39 1.239zM68.306 76.673c-.48 0-.948-.222-1.205-.62l-3.717-5.738c-.384-.593-.156-1.35.509-1.693.664-.342 1.515-.14 1.899.454l3.717 5.738c.384.593.156 1.35-.509 1.693a1.517 1.517 0 01-.694.166zM84.632 62.12c-.235 0-.475-.054-.693-.167L77.5 58.64c-.665-.342-.893-1.1-.509-1.692.384-.593 1.234-.796 1.9-.454l6.438 3.313c.665.342.893 1.1.509 1.693-.258.397-.725.62-1.206.62zM90.61 42.24h-7.436c-.767 0-1.39-.556-1.39-1.24 0-.684.623-1.24 1.39-1.24h7.435c.768 0 1.39.556 1.39 1.24 0 .684-.622 1.24-1.39 1.24zM78.195 25.672c-.48 0-.947-.222-1.205-.62-.384-.592-.156-1.35.509-1.692l6.439-3.313c.665-.342 1.515-.14 1.899.453.383.593.156 1.35-.51 1.693l-6.438 3.313a1.518 1.518 0 01-.694.166zM64.586 13.544c-.235 0-.475-.053-.693-.166-.665-.342-.893-1.1-.51-1.693l3.718-5.739c.384-.592 1.234-.795 1.899-.453s.893 1.1.509 1.693l-3.717 5.738c-.258.398-.725.62-1.206.62z"
        fill="#E86100"
        initial="hidden"
        animate="visible"
        variants={variants}
      />
      <motion.path
        d="M46 17.806c-.942 0-1.872.046-2.788.133 13.06 1.24 23.234 11.09 23.234 23.06 0 11.97-10.174 21.822-23.234 23.062.916.087 1.846.133 2.788.133 14.372 0 26.022-10.385 26.022-23.194 0-12.81-11.65-23.194-26.022-23.194z"
        fill="#E86100"
        initial="hidden"
        animate="visible"
        variants={variants}
      />
    </svg>
  );
}

export default SunIcon;
